import React from 'react';
import { Box } from '@mui/material';

import { SearchStringProvider, useSearchString } from '@barboxx/admin-utils';

import {
    CustomPageHeader,
    RootContainer,
} from '../../components/nav/RootContainer';
import { CustomerTable } from './components/CustomerTable';

function CustomerListCard() {
    const { InputComponent, searchString } = useSearchString();

    const CustomPageToolbarComponent = React.useCallback(
        () => (
            <CustomPageHeader>
                <Box gap={2} flexDirection="row" display="flex">
                    <InputComponent />
                </Box>
            </CustomPageHeader>
        ),
        [InputComponent]
    );

    return (
        <RootContainer
            maxWidth={false}
            slots={{ header: CustomPageToolbarComponent }}
        >
            <CustomerTable searchString={searchString} />
        </RootContainer>
    );
}

export function CustomerList() {
    return (
        <SearchStringProvider>
            <CustomerListCard />
        </SearchStringProvider>
    );
}
